<template>
    <div class="cta text-nav" v-if="section.cta" @click="$emit('click')">
        <strong class="label" v-html="section.cta" />
        <hero-link-icon />
    </div>
</template>

<script>
import HeroLinkIcon from "@/components/HeroLinkIcon";

export default {
    components: { HeroLinkIcon },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped lang="sass">
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/typography

.cta
    position: absolute
    z-index: 10
    bottom: var(--line-base)
    left: 0
    width: 100%
    box-sizing: border-box
    cursor: pointer
    transition: opacity var(--speed-fast) var(--motion-out), transform var(--speed-fast) var(--motion-out)
    display: flex
    flex-direction: column

    +media('>=small')
        left: 62.5%
        width: 25%
        text-align: right
        align-items: flex-end

    +media('>=large')
        left: 75%
        width: 12.5%

.scrolled
    .hero.first
        .cta
            opacity: 0
            transform: translateY(-var(--line-base))
            transition-timing-function: var(--motion-sharp), var(--motion-sharp)
</style>
